import { init, captureError } from "@appsignal/browser";

const metaContent = (name) => {
    const tag = document.head.querySelector(`meta[name="${name}"]`);
    return (tag && tag.content) || null;
};

// The front-end API key is meant to be public, and is rendered into the layout
// from APPSIGNAL_FRONTEND_API_KEY. When it is absent — development, test, or an
// environment we deliberately keep quiet — init() below does nothing at all.
const key = metaContent("appsignal_frontend_api_key");

// The running build, baked into the image as APP_REVISION. Errors and web
// vitals are tagged with it, which is what drives the version filters and
// the sourcemap lookup for backtraces.
const appVersion = metaContent("appsignal_revision");

// Turbo aborts in-flight fetches when the user navigates away. The resulting
// rejections are expected, not faults, so track navigation state and drop them.
let navigating = false;
const startNavigating = () => { navigating = true; };
const stopNavigating = () => { navigating = false; };
document.addEventListener("turbo:before-visit", startNavigating);
document.addEventListener("turbo:before-fetch-request", startNavigating);
document.addEventListener("turbo:load", stopNavigating);
document.addEventListener("turbo:before-fetch-response", stopNavigating);

// Messages that are noise rather than faults. Browser wording varies, hence
// several spellings of the same condition.
const IGNORED_MESSAGES = [
    // ResizeObserver reports these during normal layout work.
    /ResizeObserver loop completed with undelivered notifications/,
    /ResizeObserver loop limit exceeded/,
    // Client-network noise: fetches cancelled by navigation, offline devices,
    // and extensions. Chrome / Firefox / Safari respectively, then explicit aborts.
    /Failed to fetch/,
    /NetworkError when attempting to fetch resource/,
    /Load failed/,
    /aborted a request/,
    /AbortError/,
    // The Outlook link checker prefetches URLs and trips this on pages it opens.
    /Object Not Found Matching Id:\d+/
];

// Errors thrown inside a browser extension are not ours to fix, and the old SDK
// could only match on message, so they were reported in full.
const EXTENSION_SOURCE = /^(chrome|chrome-untrusted|moz|safari-web|safari|ms-browser)-extension:\/\//;

init({
    key,
    // Must be set explicitly: left unset, the SDK posts to the current origin.
    endpoint: "https://appsignal-endpoint.net",
    active: Boolean(key),
    appVersion,
    beforeError(event) {
        if (navigating) return null;
        if (event.filename && EXTENSION_SOURCE.test(event.filename)) return null;
        if (event.stack && EXTENSION_SOURCE.test(event.stack.trim())) return null;

        const message = event.message || "";
        if (IGNORED_MESSAGES.some((pattern) => pattern.test(message))) return null;

        return event;
    }
});

export { captureError };
